import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { Link } from "@nextui-org/link";
import clsx from "clsx";
import { ToastContainer } from "react-toastify";

import { Providers } from "./providers";
import { Navbar } from "@/components/navbar";
import BackToTop from "@/components/back-to-top";
import Transition from "@/components/transition";

import HomePage from "./pages/HomePage";
import CurrenciesPage from "./pages/CurrenciesPage";
import ContactUsPage from "./pages/ContactUsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import NotFoundPage from "./pages/NotFoundPage";

export default function App() {
  const year = new Date().getFullYear();

  return (
    <>
      <ToastContainer
        closeOnClick
        pauseOnFocusLoss
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        position="top-right"
        rtl={false}
        theme="light"
      />
      <Providers themeProps={{ attribute: "class", defaultTheme: "light" }}>
        <div className="relative flex flex-col h-screen">
          <Navbar />
          <main>
            <Transition>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route
                  path="/currencies"
                  element={
                    <section className="ct-section-h ct-section gap-4 py-8 md:py-10">
                      <CurrenciesPage />
                    </section>
                  }
                />
                <Route
                  path="/contact-us"
                  element={
                    <section>
                      <ContactUsPage />
                    </section>
                  }
                />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Transition>
          </main>

          <BackToTop />
          <footer className="w-full flex items-center justify-center mt-4 mb-5 py-5">
            <div className="w-5/6 flex-wrap flex flex-col items-center justify-center">
              <div className="w-full flex flex-row justify-between content-center items-center">
                <div className="w-1/2">
                  <p className="copyright text-center">
                    Copyright © <span>{year}</span>{" "}
                    <span className="ct-text-primary font-bold"> CryptoTX </span>
                    . All Rights Reserved.
                  </p>
                </div>

                <div className="w-1/2 flex flex-row items-center justify-center">
                  <ul className="flex flex-row gap-5 gap-lg-6">
                    <li>
                      <Link href="/privacy-policy">Privacy policy</Link>
                    </li>
                    <li>
                      <Link href="/terms">Terms & Conditions</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </Providers>
    </>
  );
}
